// the formula is created to approximate custom values based on values from ws-templates
const getMinFontSizeByFontSize = (fontSize) => {
  if (fontSize < 24) return fontSize;
  if (fontSize >= 64) return 48;

  return 0.65 * fontSize + 6.4;
};

export default getMinFontSizeByFontSize;
